import { render, staticRenderFns } from "./writeDocumentDetail.vue?vue&type=template&id=ebe03b78&scoped=true&"
import script from "./writeDocumentDetail.vue?vue&type=script&lang=js&"
export * from "./writeDocumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./writeDocumentDetail.vue?vue&type=style&index=0&id=ebe03b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe03b78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebe03b78')) {
      api.createRecord('ebe03b78', component.options)
    } else {
      api.reload('ebe03b78', component.options)
    }
    module.hot.accept("./writeDocumentDetail.vue?vue&type=template&id=ebe03b78&scoped=true&", function () {
      api.rerender('ebe03b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/components/writeDocumentDetail.vue"
export default component.exports